import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, Renderer2, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import * as moment from 'moment';

import { StateService, AuthService, InvoiceService } from '../../../services';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { } from '../../../shared/modals';
import { AuctionLotSearchSortType } from 'src/app/models/auction-lot-search-sort-type';
import { AppConfig } from 'src/app/config';
import { fadeAnimation } from 'src/app/shared/animations';
import { InvoiceSummaryModel } from 'src/app/models';
import { ModalPayInvoiceComponent } from 'src/app/invoice/modals';

@Component({
    selector: 'page-invoice-detail',
    styleUrls: ['./page-invoice-detail.component.scss'],
    templateUrl: './page-invoice-detail.component.html',
    animations: [fadeAnimation],
})
export class PageInvoiceDetailComponent implements OnInit {
    processing: boolean = false;
    initialized: boolean = false;
    invoiceId: number;
    InvoiceDetail: InvoiceSummaryModel = new InvoiceSummaryModel();
    isBusy: boolean = false;
    sendingEmails: boolean = false;
    address: string;
    InvoicePayment: any[];
    InvoiceNumber: string;
    AuctionId: number;
    Id: number;

    constructor(public router: Router,
        private appConfig: AppConfig,
        private activatedRoute: ActivatedRoute,
        public stateService: StateService,
        private modalService: NgbModal,
        public authService: AuthService,
        public invoiceService: InvoiceService,
        public formFunctions: FormFunctions,
        private decimalPipe: DecimalPipe
    ) {
        var me = this;
        me.invoiceId = me.activatedRoute.snapshot.params.invoiceId;

        me.LoadData();
    }

    ngOnInit() {
        let me = this;
        // Wait until the default auction is loaded
    }

    LoadData() {
        let me = this;

        me.invoiceService.FindSummaryById(me.invoiceId).subscribe(data => {
            me.InvoiceDetail = data;
            me.InvoicePayment = me.InvoiceDetail.InvoicePayments;
            me.InvoiceNumber = data.Invoice.InvoiceNumber;
            me.AuctionId = data.Invoice.AuctionId;
            me.Id = data.Invoice.Id;

            me.isBusy = false;
        });

    }

    Updated() {
        // console.log('Updated');
    }

    Cleared() {
        // console.log('Cleared');

    }

    GetTotals(totalOf) {
        let me = this;

        if (!me.InvoiceDetail || !me.InvoiceDetail.InvoiceItems) {
            return "$0.00";
        }

        let totHammer = me.InvoiceDetail.InvoiceItems.reduce((sum, item) => sum + item.TotalHammerInclGST, 0);
        let totPremium = me.InvoiceDetail.InvoiceItems.reduce((sum, item) => sum + item.PremiumIncGST, 0);
        let totGst = me.InvoiceDetail.InvoiceItems.reduce((sum, item) => sum + item.GSTPremium, 0);
        let totPayments = me.InvoiceDetail.InvoicePayments.reduce((sum, item) => sum + item.Amount, 0);
        let totAdjustmentsAmount = me.InvoiceDetail.InvoiceAdjustments.reduce((sum, item) => sum + item.Amount, 0);
        let totAdjustmentsGst = me.InvoiceDetail.InvoiceAdjustments.reduce((sum, item) => sum + item.Gst, 0);
        let totAdjustments = totAdjustmentsAmount + totAdjustmentsGst;

        if (totalOf == 'invoice') {
            return '$' + this.decimalPipe.transform((totPremium + totHammer + totAdjustments), '1.2-2');
        } else if (totalOf == 'premium') {
            return '$' + this.decimalPipe.transform((totPremium), '1.2-2');
        } else if (totalOf == 'gstincluded') {
            return '$' + this.decimalPipe.transform((totGst + totAdjustmentsGst), '1.2-2');
        } else if (totalOf == 'payments') {
            return '$' + this.decimalPipe.transform((totPayments), '1.2-2');
        } else if (totalOf == 'balance') {
            return '$' + this.decimalPipe.transform((totPremium + totHammer + totAdjustments - totPayments), '1.2-2');
        } else if (totalOf == 'adjustment') {
            return '$' + this.decimalPipe.transform((totAdjustments), '1.2-2');
        } else if (totalOf == 'balance-number-only') {
            return (totPremium + totHammer + totAdjustments - totPayments);
        }
    }

    GetBalanceNumber(): number {
        return this.GetTotals("balance-number-only") as number;
    }

    getAddress() {
        var me = this;

        let address = me.InvoiceDetail.Invoice.Address1;
        if (me.InvoiceDetail.Invoice.Address2 && me.InvoiceDetail.Invoice.Address2.trim() != "") {
            address = `${address}\n${me.InvoiceDetail.Invoice.Address2}`;
        }
        address = `${address}\n${me.InvoiceDetail.Invoice.Suburb}`;
        address = `${address}\n${me.InvoiceDetail.Invoice.State} ${me.InvoiceDetail.Invoice.Postcode}`;

        return address;
    }

    getDelAddress() {
        var me = this;

        // debugger;

        let address = me.InvoiceDetail.Invoice.DeliveryAddress1 ?? "";
        if (me.InvoiceDetail.Invoice.DeliveryAddress2 && me.InvoiceDetail.Invoice.DeliveryAddress2.trim() != "") {
            address = `${address}\n${me.InvoiceDetail.Invoice.DeliveryAddress2}`;
        }
        address = `${address}\n${(me.InvoiceDetail.Invoice.DeliverySuburb ?? "")}`;
        address = `${address}\n${(me.InvoiceDetail.Invoice.DeliveryState ?? "")}`;

        if (me.InvoiceDetail.Invoice.DeliveryPostcode) {
            address += ` ${me.InvoiceDetail.Invoice.DeliveryPostcode}`;
        }

        return address;
    }

    getBuyerPremium() {
        return this.InvoiceDetail.Invoice.BuyerPremium * 100 + '.00%';
    }

    getDate() {
        return moment(this.InvoiceDetail.Invoice.DateCreated).format('DD-MMM-YYYY');
    }

    PayNow() {
        let me = this;

        const modalRef = me.modalService.open(ModalPayInvoiceComponent, {
            scrollable: true,
            size: 'lg'
        });
        modalRef.componentInstance.InvoiceId = me.invoiceId;
        modalRef.componentInstance.PayBalance = me.GetTotals('balance-number-only');
        modalRef.componentInstance.InvoiceNumber = me.InvoiceNumber;


        modalRef.result.then((result) => {
            if (result && result != 'exit') {
                me.LoadData();
            }
        });
    }

}
